import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../core/common/selfLoder";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import useApi from "../../core/customhook/useApi";


const ResignationGrid = [
    {
        name: "Application Form",
        logo: "../assets/img/offboarding.png",
        Link: all_routes.offboardingForm,
    },
    {
        name: "Application Details",
        logo: "../assets/img/dashboard/Leave-details.png",
        Link: "/offboarding/view-offboarding",
    },
    {
        name: "Exit interview Form",
        logo: "../assets/img/dashboard/Leave-application.png",
        Link: all_routes.exitoffboardingpage,
    },
    {
        name: "Clearance Form",
        logo: "../assets/img/dashboard/Leave-details.png",
        Link: "/resignation/clearance",
    },
];


const SelfResignationGrid = () => {

    const [loading, setLoading] = useState(true);

    const { data: resignedStatus, loading: resignedStatusLoad } = useApi(
        '/api/offboarding-status', {
        method: "GET",
        autoCall: true
    }
    )

    // let filteredGrid: any = [];

    // switch (resignedStatus?.status) {
    //     case "Pending":
    //         filteredGrid = ResignationGrid.filter(
    //             item => item.name === "Application Details"
    //         );
    //         break;

    //     case "Approved":
    //         filteredGrid = ResignationGrid.filter(
    //             item =>
    //                 item.name === "Application Details" ||
    //                 item.name === "Exit interview Form" ||
    //                 item.name === "Clearance Form"
    //         );
    //         break;

    //     case "Rejected":
    //         filteredGrid = ResignationGrid.filter(
    //             item =>
    //                 item.name === "Application Form" ||
    //                 item.name === "Application Details"
    //         );
    //         break;

    //     default:
    //         filteredGrid = [];
    // }


    const statusMap: Record<string, string[]> = {
        Pending: ["Application Details"],
        Approved: ["Application Details", "Exit interview Form", "Clearance Form"],
        Rejected: ["Application Form", "Application Details"],
        Withdrawn: ["Application Form", "Application Details"]
    };

    const allowedItems =
        !resignedStatus?.status
            ? ["Application Form"]
            : statusMap[resignedStatus.status] || [];

    const filteredGrid = ResignationGrid.filter(item =>
        allowedItems.includes(item.name)
    );


    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => clearTimeout(timeout);
    }, []);
    return (
        <>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Work & Operations</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/employee-dashboard">
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Work & Operations</li>
                                    <li className="breadcrumb-item">Offboarding</li>
                                    <li className="breadcrumb-item active">
                                        <Link to={"#"} aria-current="page">
                                            Self Application
                                        </Link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Self Application</h5>
                        </div>
                        <div className="card-body">
                            <div className="row h-100">
                                {filteredGrid.map((card: any, index: any) => (
                                    <div
                                        key={index}
                                        className="col-6 col-sm-4 col-md-3 mb-4 d-flex"
                                    >
                                        <Link to={card.Link} className="w-100">
                                            <div className="card h-100 shadow-sm px-2 py-3 px-md-4 px-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                                                <img
                                                    src={card.logo}
                                                    alt={card.name}
                                                    className="mb-3"
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        objectFit: "contain",
                                                    }}
                                                />
                                                <h5 className="mb-0">{card.name}</h5>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                    <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
                </div>
            </div>
        </>
    );
};

export default SelfResignationGrid;